(function () {
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-scroll-to-picker]');
    if (!trigger) return;

    // Targets the color step specifically via its existing data-vps-color-selector
    // attribute (already used by variant-picker-simple.js for its own logic, read-only
    // here) rather than a positional selector like .vps__step:first-of-type — .vps__step
    // is shared by both the color and size fieldsets, and this stays correct even if
    // their order in the DOM ever changes. Falls back to whichever .vps__step exists
    // (e.g. size-only products with no color option), then to .vps itself.
    var colorGrid = document.querySelector('[data-vps-color-selector]');
    var target = (colorGrid && colorGrid.closest('.vps__step')) || document.querySelector('.vps__step') || document.querySelector('.vps');
    if (!target) return;

    e.preventDefault();

    // --header-height is kept in sync with the real header height by header.liquid
    // (both the sticky and static header custom elements set it on the document root),
    // so it accounts for whichever sticky_header_type is active.
    var headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerOffset - 24;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: targetPosition, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();
